module.exports = __webpack_public_path__ + "static/2040fcfb.disconnect_modal_fr.png";